import { render, staticRenderFns } from "./FriendInfo.vue?vue&type=template&id=6dce90bb&scoped=true"
import script from "./FriendInfo.vue?vue&type=script&lang=ts"
export * from "./FriendInfo.vue?vue&type=script&lang=ts"
import style0 from "./FriendInfo.vue?vue&type=style&index=0&id=6dce90bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce90bb",
  null
  
)

export default component.exports